/* JUICi cart drawer: theme-native replacement for the Kaching Cart app drawer.
   - Same 5-minute "your items are reserved for mm:ss" timer as Kaching (sessionStorage, resets when an item is
     added, bar hides at 00:00, cart is NOT cleared at zero).
   - Same HydrateHER upsell (one-time, no extra discount, hidden while the cart is empty).
   - Gift lines are NOT added or removed here: the buy box payload adds them and beauty-bundle-guard.js polices
     removals, exactly as with Kaching (whose own gift rules and promotions bar were switched off).
   All cart calls go through window.fetch so beauty-bundle-guard.js still sees every mutation.
   Speed (2026-10-29): the drawer's own add/change calls ask Shopify for the rendered drawer in the same response
   (Section Rendering via the `sections` param), so each action is ONE request and ONE render, with no 650ms wait
   and no second /?sections= fetch. They carry ?jc-skip so our fetch hook doesn't schedule a duplicate refresh. */
(function(){
  if(window.__jcCartInstalled) return; window.__jcCartInstalled=true;
  var ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var TKEY='jc-cart-timer';
  function fmt(s){return String(Math.floor(s/60)).padStart(2,'0')+':'+String(s%60).padStart(2,'0')}
  var SECTIONS='cart-drawer,cart-icon-bubble';
  function json(url,body){return window.fetch(url,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})}

  class JcCart extends HTMLElement{
    connectedCallback(){
      if(this._init) return; this._init=true;
      this.mins=parseInt(this.dataset.timerMin||'5',10);
      this.addEventListener('click',e=>this.onClick(e));
      document.addEventListener('keydown',e=>{if(e.key==='Escape'&&this.hasAttribute('open'))this.close()});
      this.count=parseInt(this.dataset.count||'0',10);
      this.startTimer(false);
    }
    get isOpen(){return this.hasAttribute('open')}
    open(){
      if(this.isOpen) return;
      this._last=document.activeElement;
      this.setAttribute('open','');this.setAttribute('aria-hidden','false');
      document.documentElement.classList.add('jcc-lock-scroll');
      var p=this.querySelector('.jcc-panel'); setTimeout(()=>{try{p.focus({preventScroll:true})}catch(e){}},50);
      document.dispatchEvent(new CustomEvent('jc-cart:open'));
    }
    close(){
      this.removeAttribute('open');this.setAttribute('aria-hidden','true');
      document.documentElement.classList.remove('jcc-lock-scroll');
      if(this._last&&this._last.focus) try{this._last.focus({preventScroll:true})}catch(e){}
    }
    /* timer: identical semantics to Kaching Cart's announcement bar */
    startTimer(reset){
      if(!this.mins) return;
      if(reset) sessionStorage.removeItem(TKEY);
      var saved=parseInt(sessionStorage.getItem(TKEY)||'',10);
      this.left=saved>0?saved:this.mins*60;   /* Kaching: a stored 0 restarts at the full time on the next page */
      clearInterval(this._t);
      this.paintTimer();
      sessionStorage.setItem(TKEY,String(this.left));
      this._t=setInterval(()=>{
        if(this.left>0){this.left--;sessionStorage.setItem(TKEY,String(this.left));this.paintTimer()}
        else clearInterval(this._t);
      },1000);
    }
    paintTimer(){
      var bar=this.querySelector('[data-jc-timer]'); if(!bar) return;
      var show=this.left>0&&this.count>0;
      bar.hidden=!show;
      var t=bar.querySelector('[data-jc-time]'); if(t) t.textContent=fmt(Math.max(0,this.left||0));
    }
    async refresh(){
      var me=this._rq=(this._rq||0)+1;
      try{
        var r=await window.fetch(ROOT+'?sections='+SECTIONS,{credentials:'same-origin',headers:{Accept:'application/json'}});
        if(!r.ok) throw new Error('sections '+r.status);
        var s=await r.json();
        if(me===this._rq) this.render(s);   /* a newer refresh/render already landed: drop this stale one */
      }catch(e){console.warn('[jc-cart] refresh failed',e)}
      finally{this.classList.remove('is-busy')}
    }
    /* paint the drawer from a Section Rendering payload ({'cart-drawer':html,'cart-icon-bubble':html}) */
    render(s){
      if(!s||!s['cart-drawer']) return false;
      this._rq=(this._rq||0)+1;
      try{
        var doc=new DOMParser().parseFromString(s['cart-drawer'],'text/html');
        var nd=doc.querySelector('jc-cart'); if(!nd) return;
        ['[data-jc-body]','[data-jc-foot]'].forEach(sel=>{var a=this.querySelector(sel),b=nd.querySelector(sel);if(a&&b)a.innerHTML=b.innerHTML});
        var fw=this.querySelector('[data-jc-foot-wrap]'),nfw=nd.querySelector('[data-jc-foot-wrap]'); if(fw&&nfw) fw.hidden=nfw.hidden;
        var tot=this.querySelector('[data-jc-total]'),nt=nd.querySelector('[data-jc-total]'); if(tot&&nt) tot.textContent=nt.textContent;
        this.count=parseInt(nd.dataset.count||'0',10); this.dataset.count=this.count;
        document.querySelectorAll('[data-count]:not(jc-cart)').forEach(x=>x.textContent=this.count);
        if(s['cart-icon-bubble']){var bub=document.getElementById('cart-icon-bubble');if(bub){var bd=new DOMParser().parseFromString(s['cart-icon-bubble'],'text/html');var src=bd.querySelector('.shopify-section');if(src)bub.innerHTML=src.innerHTML}}
        this.paintTimer();
        return true;
      }catch(e){console.warn('[jc-cart] render failed',e); return false}
      finally{this.classList.remove('is-busy')}
    }
    async onAdded(openIt,sections){ this.startTimer(true); if(!(sections&&this.render(sections))) await this.refresh(); if(openIt!==false) this.open(); }
    async change(key,q){
      this.classList.add('is-busy');
      var s=null;
      try{ var r=await json(ROOT+'cart/change.js?jc-skip=1',{id:key,quantity:q,sections:SECTIONS}); var b=await r.json().catch(()=>({}));
           if(!r.ok) alert((b&&b.description)||'sorry, that didn\'t work. please try again.'); else s=b.sections; }
      catch(e){console.warn('[jc-cart] change failed',e)}
      if(!(s&&this.render(s))) await this.refresh();
    }
    async onClick(e){
      var t=e.target;
      if(t.closest('[data-jc-close]')){e.preventDefault();this.close();return}
      var rm=t.closest('[data-jc-remove]'); if(rm){e.preventDefault();this.change(rm.dataset.key,0);return}
      var q=t.closest('[data-jc-qty]'); if(q){e.preventDefault();this.change(q.dataset.key,Math.max(0,parseInt(q.dataset.q,10)));return}
      var up=t.closest('[data-jc-upsell-add]');
      if(up){e.preventDefault(); if(up.disabled) return; up.disabled=true; var o=up.textContent; up.textContent='adding...';
        try{ var r=await json(ROOT+'cart/add.js?jc-skip=1',{items:[{id:parseInt(up.dataset.variant,10),quantity:1}],sections:SECTIONS}); if(!r.ok) throw new Error(r.status);
             var b=await r.json().catch(()=>({})); this.startTimer(true); if(!(b.sections&&this.render(b.sections))) await this.refresh();
             document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{jc:true}})); }
        catch(err){console.warn('[jc-cart] upsell add failed',err);alert('sorry, we couldn\'t add that. please try again.')}
        finally{up.disabled=false;up.textContent=o}
        return}
      var co=t.closest('[data-jc-checkout]'); if(co){co.setAttribute('aria-busy','true')}
    }
  }
  if(!customElements.get('jc-cart')) customElements.define('jc-cart',JcCart);
  function cart(){return document.querySelector('jc-cart')}

  /* every successful add (buy box, upsell, any theme form/app) resets the timer, refreshes and opens the drawer;
     every other cart mutation just refreshes it. Mirrors Kaching's fetch interception. */
  var of=window.fetch, pending=null, pendingAdd=false;
  function soon(isAdd){ if(isAdd) pendingAdd=true; clearTimeout(pending);
    pending=setTimeout(function(){ var c=cart(), a=pendingAdd; pending=null; pendingAdd=false; if(!c) return; if(a) c.onAdded(true); else c.refresh(); }, pendingAdd?650:160); }
  window.fetch=function(input,init){
    var url=typeof input==='string'?input:(input&&input.url)||'';
    var p=of.apply(this,arguments);
    var m=/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.exec(url);
    if(m&&!/[?&]jc-skip/.test(url)){
      p.then(function(res){ if(!res||!res.ok) return; var c=cart(); if(!c) return;
        soon(m[1]==='add'); }).catch(function(){});
    }
    return p;
  };
  /* events we fire ourselves after rendering carry detail.jc and are ignored here (no double refresh) */
  ['cart:updated','cart:refresh'].forEach(function(ev){document.addEventListener(ev,function(e){ if(e.detail&&e.detail.jc) return; if(cart()) soon(false); })});

  /* concept buy box hooks (jc-concept.js): keep its exact /cart/add.js payload (JC_buildItems), open our drawer */
  function data(){var el=document.querySelector('script[data-jc-product]');return el?JSON.parse(el.textContent):null}
  var jcOpen=function(){var c=cart(); if(c){c.refresh();c.open()} else window.location.href=ROOT+'cart'};
  var jcAdd=async function(st,isSub,root,trigger){
    var D=data(); if(!D||typeof window.JC_buildItems!=='function'){alert('Could not add to cart. Please try again.');return}
    var items=window.JC_buildItems(D,st.tier,st.multi?null:st.flav,st.multi,isSub);
    if(typeof items==='string'){alert(items);return}
    window.__jcLastItems=items;
    var btn=trigger||root.querySelector('[data-atc]'); var isAtc=btn&&btn.hasAttribute('data-atc');
    var orig=btn?btn.innerHTML:''; if(btn){btn.disabled=true; if(isAtc) btn.textContent='adding...'; else btn.classList.add('is-busy')}
    try{
      /* same single items[] payload as before (3PL lines unchanged); `sections` only adds the rendered drawer to the reply */
      var res=await window.fetch(ROOT+'cart/add.js?jc-skip=1',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items,sections:SECTIONS})});
      if(!res.ok) throw new Error('cart add failed: '+res.status+' '+(await res.text().catch(function(){return ''})));
      var added=await res.json().catch(function(){return {}});
      var secs=added.sections; delete added.sections;
      var c=cart(); if(c) await c.onAdded(true,secs);
      try{ if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'wmp-offer',cartData:added}) }catch(e){}
      document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart:added,jc:true}}));
    }catch(err){console.error('[jc] cart add error',err);alert('Could not add to cart. Please try again.')}
    finally{ if(btn){btn.disabled=false; if(isAtc) btn.innerHTML=orig; else btn.classList.remove('is-busy')} }
  };
  try{
    Object.defineProperty(window,'JC_openCart',{configurable:true,get:function(){return jcOpen},set:function(){}});
    Object.defineProperty(window,'JC_addToCart',{configurable:true,get:function(){return jcAdd},set:function(){}});
  }catch(e){window.JC_openCart=jcOpen;window.JC_addToCart=jcAdd}

  /* cart icons / links open the drawer (same idea as Kaching's cartButtonSelectors) */
  var SEL='#cart-icon-bubble,.header__icon--cart,[data-cart]:not(jc-cart),a[href="/cart"],a[href$="/cart"]:not([href*="/products/"])';
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest(SEL); if(!a||a.closest('jc-cart')) return;
    var c=cart(); if(!c) return;
    e.preventDefault(); e.stopPropagation(); c.refresh(); c.open();
  },true);

  /* classic product forms elsewhere on the site (old templates): add via AJAX and open the drawer instead of /cart */
  document.addEventListener('submit',function(e){
    var f=e.target; if(!f||!f.action||!/\/cart\/add(\?|$)/.test(f.action)||f.closest('jc-cart')) return;
    if(!cart()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var fd=new FormData(f);
    window.fetch(ROOT+'cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}}).then(function(r){if(!r.ok) return r.json().then(function(m){alert((m&&m.description)||'Could not add to cart. Please try again.')})}).catch(function(){});
  },true);
})();
